<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            {{ownerObj.title}}
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.oexe"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="build"
            hint="execution team"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.ores"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="category"
            hint="reasource team"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.oplan"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="bar_chart"
            hint="planning team"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.oops"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="notifications"
            hint="ops support"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>      
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.oeng"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="settings"
            hint="technical support"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        oexe: "",
        oplan: "",
        ores: "",
        oops: "",
        oeng: ""
      },
      orgForm: {
        oexe: "",
        oplan: "",
        ores: "",
        oops: "",
        oeng: ""
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.oexe = this.getDetail.char.oexe;
    this.localForm.oplan = this.getDetail.char.oplan;
    this.localForm.ores = this.getDetail.char.ores;
    this.localForm.oops = this.getDetail.char.oops;
    this.localForm.oeng = this.getDetail.char.oeng;

    this.orgForm.oexe = this.getDetail.char.oexe;
    this.orgForm.oplan = this.getDetail.char.oplan;
    this.orgForm.ores = this.getDetail.char.ores;
    this.orgForm.oops = this.getDetail.char.oops;
    this.orgForm.oeng = this.getDetail.char.oeng;
  },
  mixins: [docRevsModFunctions, ruleTextfield, apptheme],
  computed: {
    ...mapGetters(["getDetail", "getDetailBasic", "getDetailChar"]),
    ownerObj() {
      let obj = {
        title: ""
      };
      if (this.getDetailBasic.tag === "M5") {
        obj.title = "Work Call Ownership";
      } else {
        obj.title = "Proces Ownership";
      }
      return obj;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line

      if (
        this.localForm.oexe !== this.orgForm.oexe &&
        this.localForm.oexe !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.oexe = this.localForm.oexe;
        // basic
        char.oexe = this.localForm.oexe;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.oplan !== this.orgForm.oplan &&
        this.localForm.oplan !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.oplan = this.localForm.oplan;
        // basic
        char.oplan = this.localForm.oplan;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.ores !== this.orgForm.ores &&
        this.localForm.ores !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ores = this.localForm.ores;
        // basic
        char.ores = this.localForm.ores;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.oops !== this.orgForm.oops &&
        this.localForm.oops !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.oops = this.localForm.oops;
        // basic
        char.oops = this.localForm.oops;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.oeng !== this.orgForm.oeng &&
        this.localForm.oeng !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.oeng = this.localForm.oeng;
        // basic
        char.oeng = this.localForm.oeng;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
